import React from 'react';
import { Card, CardContent, Typography, Box, Avatar, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import { getCurrencySymbolV2, numberFormatter } from '../../../../utils/currency';
import { useSpring, animated } from '@react-spring/web';

const getInitials = (name = '') => {
	const nameParts = name.trim().split(' ');
	if (nameParts.length > 1) {
		return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
	}
	return name.substring(0, 2).toUpperCase();
};

const WarriorManagerWidgetComponent = ({ details, isLoading, currentDate }) => {
	const managerName = details?.name || 'Not Available';
	const profilePhotoUrl = details?.profile_photo_url;
	const totalCustomersCount = details?.total_customers_count ?? '0';
	const totalInvoicesCount = details?.total_invoices ?? '0';
	const totalCompletedOrdersCount = details?.total_completed_orders ?? '0';
	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

	const defaultCurrency = selectedCurrency === 'all' ? 'usd' : selectedCurrency;
	const { number } = useSpring({
		from: { number: 0 },
		to: details?.total_sales?.[defaultCurrency] ?? 0,
        delay: 0,
        config: { mass: 1, tension: 120, friction: 14 },
	});

	return (
		<Card sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgb(0 0 0 / 0.05)', height: '230px' }}>
			<CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
				{/* Header */}
				<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
					<div className={`text-lg fw-500`}>
						Warrior Of The Month
					</div>
					<Typography variant="subtitle2" color="text.secondary">{currentDate}</Typography>
				</Box>

				<Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
					{isLoading ? (
						<>
							<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
								<Skeleton variant="circular" width={120} height={120} />
								<Skeleton variant="text" width="60%" height={30} sx={{ mt: 2 }} />
							</Box>

							<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', pl: 2 }}>
								<Skeleton variant="text" width="80%" height={60} />
								<Skeleton variant="text" width="50%" height={25} sx={{ mt: 2 }} />
								<Skeleton variant="text" width="60%" height={25} />
							</Box>
						</>
					) : (
						<>
							<Box
								sx={{
									flex: 1,
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									position: 'relative'
								}}
							>
								<Avatar src={profilePhotoUrl} sx={{ width: 120, height: 120, bgcolor: 'primary.light', zIndex: 1 }}>
									<h1>{getInitials(managerName)}</h1>
								</Avatar>
								<Typography variant="h6" fontWeight="medium" sx={{ mt: 2, zIndex: 1 }}>
									{managerName}
								</Typography>
							</Box>

							<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', pl: 2 }}>
								<>
									<div className="flex gap-1">
										<div style={{ marginTop: `${selectedCurrency === 'aed' ? '-2px' : '0'}`, fontSize: '20px', paddingBottom: '10px' }}>
											{getCurrencySymbolV2(selectedCurrency, 'usd', '20px', '16px')}
										</div>

										<animated.span style={{ fontSize: '20px', fontWeight: '600' }}>
											{number.to((n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
										</animated.span>
									</div>
								</>
								{/*<div className="" style={{ fontSize: '20px', fontWeight: '600', paddingBottom: '10px' }}>*/}
								{/*	{getCurrencySymbolV2(selectedCurrency, 'eur', '11px', '11px')}*/}
								{/*	<animated.span style={{ fontSize: '20px', fontWeight: '600' }}>*/}
								{/*		{number.to((n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}*/}
								{/*	</animated.span>*/}
								{/*</div>*/}
								{/*<Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>*/}
								{/*	256,000 Pcs Sold*/}
								{/*</Typography>*/}
								<Typography variant="body1" color="text.secondary">
									{totalCustomersCount} New customers
								</Typography>
								<Typography variant="body1" color="text.secondary">
									{totalInvoicesCount} Invoices
								</Typography>
								<Typography variant="body1" color="text.secondary">
									{totalCompletedOrdersCount} Completed Orders
								</Typography>
							</Box>
						</>
					)}
				</Box>
			</CardContent>
		</Card>
	);
};

export default WarriorManagerWidgetComponent;